"use client";
import Link from "next/link";
import DynamicImage from "../DynamicImages/DynamicImage";
import { allCategoryList } from "./arrayCategorylist";
import { useDispatch } from "react-redux";
import { AddNewBreadcrum } from "@/redux/slices/breadcrumSlice";

const Banner = ({categoryType}) => {
  const dispatch = useDispatch();
  const updateBreadcrumb = (breadcrumb) => {
      dispatch(AddNewBreadcrum(breadcrumb));
    };

  const DataResponse = categoryType && allCategoryList.find(item => item[categoryType])?.[categoryType]; 

  return (
    <>
    {categoryType && DataResponse && <div>
      <div className=" text-center py-10 px-5 bg-[#F1F1F1] slg:py-[30px]">
        <h1 className="text-[#0A223C] text-[48px] leading-[72px] font-bold slg:text-[40px] slg:leading-[60px]  ">
          {DataResponse?.title === "Laundry"? "Washers & Dryers": DataResponse?.title}
        </h1>
      </div>
      <div className="bg-[#0A223C]">
        <div className="  w-full ">
          <div className=" w-full grid grid-cols-2 min-h-[387px] relative slg:flex slg:flex-col-reverse">
            <div className=" slg:hidden">

            </div>
            
            <div className=" flex flex-col justify-center max-w-[1440px] px-[20px] absolute top-0 left-0 right-0 bottom-0 mx-auto my-0 slg:top-auto slg:bottom-auto slg:relative slg:py-[40px] slg:ml-0">
              <div className=" text-white max-w-[695px]  ">
                <h2 className=" text-[40px] leading-[68px] font-semibold slg:text-[34px] slg:leading-[46px]">
                 {DataResponse?.BannerData?.subheading}
                </h2>
                <p className=" text-[24px] leading-[36px] font-medium slg:text-[18px] slg:leading-[26px]">
                 {DataResponse?.BannerData?.descriptionTxt}
                </p>
                <div className="mt-[24px] slg:mt-[20px]">
                  <Link  className="text-[16px] slg:inline-block leading-6 px-5 py-[10px] text-[#0A223C] rounded-[8px] bg-white font-semibold"
                    href={DataResponse?.slug} 
                    onClick={() => {
                      updateBreadcrumb([
                        {
                          name: DataResponse?.title === "Laundry"? "Washers & Dryers": DataResponse?.title,
                          url: DataResponse?.slug,
                        }
                      ]);
                    }}
                    > 
                    Shop All
                  </Link>
                </div>
              </div>
            </div>
            <div className=" relative slg:h-[245px]">
              <DynamicImage
                src={DataResponse?.BannerData?.bannerImg}
                alt="banner"
                fill
                className="object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>}</>
  );
};

export default Banner;
